module.exports = __webpack_public_path__ + "static/media/coldQuietDark.9664c576.jpg";